module.exports = __webpack_public_path__ + "static/media/user-ico.1afb2a01.svg";